<template>
  <div
    class="find-password-container all-center"
    style="height: 100%; width: 800px; margin: auto;"
  >
    <v-stepper v-model="page" style="box-shadow: none; width: 100%;">
      <v-stepper-header
        style="box-shadow: none; border-bottom: 1px solid #9e9e9e;"
      >
        <v-stepper-step :complete="page > 1" step="1">
          {{ $i18n.t("login.Please_enter_email_address") }}
        </v-stepper-step>

        <v-divider />

        <v-stepper-step :complete="page > 2" step="2">
          {{ $i18n.t("login.email_activation") }}
        </v-stepper-step>

        <v-divider />

        <v-stepper-step :complete="page > 3" step="3">
          {{ $i18n.t("login.confirm_password") }}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4">
          {{ $i18n.t("login.result") }}
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items style="height: 325px;">
        <v-stepper-content step="1" style="height: 100%;">
          <div style="height: 200px; padding-top: 20px;">
            <v-form v-model="valid">
              <div class="d-flex">
                <v-text-field
                  style="width: 100px !important;"
                  v-model="email"
                  name="login"
                  :label="$i18n.t('login.Please_enter_email_address')"
                  type="text"
                  :rules="[testEmail]"
                  required
                  outlined
                />
              </div>
            </v-form>
          </div>
          <div style="width: 100%;"></div>
          <v-btn
            :disabled="!valid"
            width="100%"
            color="primary"
            @click="verifyEmail"
          >
            下一步
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="2" style="height: 100%;">
          <div style="height: 200px;">
            <div>
              <h3>请检查您的电子邮箱</h3>
              请查收邮件,我们已经向你的邮箱发送了一封邮件,
              其中包含了您账号的继续操作链接,点击操作可完成您账号的密码找回.
            </div>
            <div class="pt-4">
              <h3>没有收到电子邮件?</h3>
              检查您的邮箱(包含垃圾邮件文件夹),查找机数公司给您发送的邮件.
              点击重新发送，重新获取链接。
            </div>
          </div>

          <v-btn
            width="100%"
            color="primary"
            @click="reSendEmail"
            :disabled="ReSend"
          >
            {{ timer }}
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3" style="height: 100%;">
          <div style="height: 200px; margin-top: 30px;">
            <v-form v-model="secValid">
              <v-text-field
                id="password"
                v-model="password"
                name="password"
                :label="$i18n.t('login.Please_enter_your_password')"
                :rules="[counter]"
                required
                outlined
                :type="isShowPassword ? 'text' : 'password'"
              >
                <v-fade-transition slot="append" mode="out-in">
                  <v-icon
                    :key="`icon-${isShowPassword}`"
                    @click="isShowPassword = !isShowPassword"
                    v-text="isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  />
                </v-fade-transition>
              </v-text-field>

              <v-text-field
                v-model.trim="passwordR"
                :label="$i18n.t('login.confirm_password')"
                :type="isShowPassword ? 'text' : 'password'"
                :append-icon="isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="isShowPassword = !isShowPassword"
                :rules="[counter]"
                :error="passwordR !== password"
                :error-messages="
                  passwordR !== password
                    ? $i18n.t('login.confirm_password')
                    : ''
                "
                outlined
              >
                <v-fade-transition slot="append" mode="out-in">
                  <v-icon
                    :key="`icon-${isShowPassword}`"
                    @click="isShowPassword1 = !isShowPassword1"
                    v-text="isShowPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                  />
                </v-fade-transition>
              </v-text-field>
            </v-form>
          </div>

          <v-btn
            :disabled="!secValid"
            width="100%"
            color="primary"
            @click="findBackPWD"
          >
            下一步
          </v-btn>
        </v-stepper-content>
        <v-stepper-content step="4" style="height: 100%;">
          <div
            class="mb-12 d-flex justify-center flex-column align-center"
            style="height: 200px;"
          >
            <div class="mb-10">
              <h3>修改成功,点击确定按钮重新登录</h3>
            </div>
          </div>
          <v-btn color="primary" @click="reLogin" width="100%">确定</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "FindPassword",
  components: {},
  mounted() {
    if (this.$route.query.token) {
      this.page = 3;
      window.sessionStorage.setItem(
        "accessToken",
        JSON.stringify(this.$route.query.token)
      );
    }
  },
  data() {
    return {
      email: "",
      password: "",
      passwordR: "",
      isShowPassword: false,
      isShowPassword1: false,
      valid: false,
      secValid: false,
      step: 1,
      page: 0,
      ReSend: false,
      timer: "重新发送",
    };
  },
  methods: {
    ...mapActions(["forgetPassword", "findBackPassword"]),
    reSendEmail() {
      this.forgetPassword({ email: this.email }).then((res) => {
        this.ReSend = true;
        this.timer = 60;
        let setTimer = setInterval(() => {
          this.timer = this.timer - 1;
          if (this.timer === 0) {
            clearInterval(setTimer);
            this.timer = "重新发送";
            this.ReSend = false;
          }
        }, 1000);
      });
    },
    verifyEmail() {
      this.forgetPassword({ email: this.email }).then((res) => {
        if (res.data.code === 200) {
          this.page = 2;
        } else {
        }
      });
    },
    findBackPWD() {
      this.findBackPassword({ password: this.$md5(this.password) }).then(
        (res) => {
          if (res.data.code === 200) {
            this.page = 4;
          }
        }
      );
    },
    reLogin() {
      this.$router.push("/");
    },
    required(value) {
      return !!value || this.$i18n.t("login.What is required");
    },
    testEmail(value) {
      const pattern = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      return (
        pattern.test(value) ||
        this.$i18n.t("login.Please enter the correct mailbox")
      );
    },
    counter(value) {
      return (
        value.length >= 8 ||
        this.$i18n.t("login.Cannot be less than 8 characters")
      );
    },
  },
};
</script>

<style lang="scss">
.find-password-container {
  .v-stepper__wrapper {
    width: 400px;
    height: 100%;
    margin-left: 164px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .v-stepper__label {
    display: inline-block !important;
  }
}
</style>
